import { getRequest } from '../api-handler';
import { InstrumentDetailDto } from './instrument';

export const InstrumentApi = {
  getById: (id: number) => getRequest<InstrumentDetailDto>(`/instruments/${id}`)
};
